import {Store, bindActionCreators} from 'redux'
import {setFormFactor} from '../../../../commons/actions/environment'
import {setActiveElement} from '../../../../commons/actions/focus-handler'
import {setPlaceDonationError, setSeatingError} from '../reducers/seating/errors'
import {resetFilters, selectLocation, selectPrice} from '../reducers/seating/filters'
import {
  selectPlace,
  setShowAccessibilityMode,
  setShowMobileBasket,
  setShowPlaceDescription,
  setShowPricingOptionsPlace,
  unselectPlace,
} from '../reducers/seating/mode'
import {updatePlace} from '../reducers/seating/places'
import {Actions} from '../types/actions'
import {addToCalendarClicked, addToCalendarOptionClicked} from './calendar'
import {
  checkout,
  clearCheckout,
  editStep,
  getDiscount,
  handleNextStep,
  nextFormClicked,
  setExpandedTicketIndex,
  setTicketDetails,
  setUseBuyerDetails,
  setValidPaymentAdded,
  submitCheckoutStep,
} from './checkout'
import {applyCoupon, removeCoupon, resetCouponCode} from './coupon'
import {changeEvent, getMembers, getMembersOld, shareEvent} from './event'
import {applyGiftCard, removeGiftCard, resetGiftCardCode} from './gift-card'
import {joinGroup} from './groups'
import {clearInvoice} from './invoice'
import {detailsPageLoaded, formPageLoaded, thankYouPageLoaded, ticketedThankYouPageLoaded} from './loaded'
import {ensureLoginForMembersOnly, openMembersModal, promptLogin, promptLoginOld} from './members'
import {
  closeNativeModal,
  closeUpgradeToPremium,
  openCantCompletePaymentModal,
  openCheckoutUnavailable,
  openConfirmRsvp,
  openHeadlessErrorModal,
  openOccurrencesModal,
  openPolicyDetailsModal,
  openRecurringEventsModal,
  openSeatingPlan,
  openTicketsDetailsModal,
  openTicketsDownloadModal,
  openTimeExpiredModal,
} from './modals'
import {
  navigateBack,
  navigateOld,
  navigateTo,
  navigateToChangeRsvp,
  navigateToChangeRsvpOld,
  navigateToDetails,
  navigateToDetailsOld,
  navigateToForm,
  navigateToFormOld,
  navigateToHomePage,
  navigateToMainPage,
  navigateToOrder,
  navigateToOrderOld,
  navigateToTicketsPicker,
  navigateToTicketsPickerOld,
  navigateViaEditor,
  scrollToElement,
} from './navigation'
import {getOccurrences} from './occurrences'
import {downloadTickets} from './order-success'
import {applyPlan, getPlanList, openMembershipPicker} from './paid-plans'
import {paymentMethodSelected, placeOrderButtonClicked} from './payment'
import {
  expressCheckout,
  getCheckoutData,
  getOrderTicketsDownloadUrl,
  placeOrderOld,
  pollOrder,
  updateOrder,
  updateOrderOld,
  updatePaymentMethod,
} from './placed-order'
import {openPolicyModal, toggleAgreePolicies, toggleAgreePoliciesOld} from './policies'
import {registrationButtonClicked} from './registration'
import {
  cancelReservation,
  clearReservation,
  clearReservationError,
  initiateEcomCheckoutFlow,
  reserveTickets,
} from './reservation'
import {
  changeMemberRsvp,
  changeResponse,
  changeResponseOld,
  deleteRsvp,
  deleteRsvpOld,
  editRsvpStep,
  editRsvpStepOld,
  handleNextRsvpStep,
  handleRSVP,
  resetRsvpError,
  resetRsvpErrorOld,
  sendRsvpOld,
  submitRsvpStep,
  updateRsvpOld,
  updateRsvpStatus,
  updateRsvpStatusOld,
} from './rsvp'
import {navigateToSchedulePage} from './schedule'
import {seatingMapButtonClick} from './seating/bi'
import {seatingCheckout} from './seating/checkout'
import {
  addPlaceDonation,
  clickPlace,
  resetAreaCounterValue,
  selectPlacePricingOption,
  setAreaCounterValue,
  setPlaceQuantity,
} from './seating/place'
import {changeTicketDonation, selectTicket, setDonationError} from './selected-tickets'
import {getStaticMapUrl} from './static-map'
import {collapseDescription, expandDescription} from './tickets-picker'

export const getExportedActions = (store: Store): Actions => {
  const dispatchActions = {
    navigateToForm,
    navigateToFormOld,
    navigateToMainPage,
    navigateToHomePage,
    detailsPageLoaded,
    formPageLoaded,
    thankYouPageLoaded,
    ticketedThankYouPageLoaded,
    changeMemberRsvp,
    registrationButtonClicked,
    resetCouponCode,
    resetGiftCardCode,
    removeCoupon,
    removeGiftCard,
    resetRsvpErrorOld,
    resetRsvpError,
    sendRsvpOld,
    updateRsvpOld,
    reserveTickets,
    selectTicket,
    ensureLoginForMembersOnly,
    expandDescription,
    collapseDescription,
    getMembers,
    getMembersOld,
    getPlanList,
    openMembershipPicker,
    promptLoginOld,
    promptLogin,
    navigateToTicketsPicker,
    navigateToTicketsPickerOld,
    openCheckoutUnavailable,
    updateOrder,
    updateOrderOld,
    placeOrderOld,
    paymentMethodSelected,
    placeOrderButtonClicked,
    navigateToDetailsOld,
    navigateToDetails,
    nextFormClicked,
    openHeadlessErrorModal,
    openPolicyDetailsModal,
    openTicketsDetailsModal,
    openTicketsDownloadModal,
    openOccurrencesModal,
    cancelReservation,
    applyCoupon,
    applyGiftCard,
    addToCalendarClicked,
    addToCalendarOptionClicked,
    applyPlan,
    handleRSVP,
    checkout,
    submitCheckoutStep,
    editStep,
    openTimeExpiredModal,
    openCantCompletePaymentModal,
    setValidPaymentAdded,
    navigateOld,
    navigateViaEditor,
    setUseBuyerDetails,
    setTicketDetails,
    clearInvoice,
    navigateToOrder,
    navigateToOrderOld,
    navigateToChangeRsvp,
    navigateToChangeRsvpOld,
    setExpandedTicketIndex,
    handleNextStep,
    openMembersModal,
    clearCheckout,
    getDiscount,
    downloadTickets,
    shareEvent,
    toggleAgreePoliciesOld,
    toggleAgreePolicies,
    openPolicyModal,
    submitRsvpStep,
    handleNextRsvpStep,
    editRsvpStepOld,
    editRsvpStep,
    changeResponseOld,
    changeResponse,
    setFormFactor,
    closeNativeModal,
    navigateToSchedulePage,
    openRecurringEventsModal,
    joinGroup,
    openSeatingPlan,
    openConfirmRsvp,
    setActiveElement,
    setPlaceQuantity,
    updatePlace,
    selectPrice,
    selectLocation,
    setShowAccessibilityMode,
    selectPlace,
    unselectPlace,
    setSeatingError,
    resetFilters,
    seatingMapButtonClick,
    clearReservation,
    clearReservationError,
    initiateEcomCheckoutFlow,
    changeTicketDonation,
    setDonationError,
    addPlaceDonation,
    setPlaceDonationError,
    setShowPricingOptionsPlace,
    setShowMobileBasket,
    setShowPlaceDescription,
    clickPlace,
    seatingCheckout,
    selectPlacePricingOption,
    updateRsvpStatusOld,
    updateRsvpStatus,
    deleteRsvpOld,
    deleteRsvp,
    getOrderTicketsDownloadUrl,
    getStaticMapUrl,
    navigateTo,
    expressCheckout,
    scrollToElement,
    updatePaymentMethod,
    setAreaCounterValue,
    resetAreaCounterValue,
    pollOrder,
    getOccurrences,
    changeEvent,
    closeUpgradeToPremium,
    getCheckoutData,
    navigateBack,
  }

  return {
    ...bindActionCreators(dispatchActions, store.dispatch),
  }
}
